export const REQUEST = 'SPORTS/REQUEST';
export const RECEIVE = 'SPORTS/RECEIVE';